/**
 * Shared validation helpers for Nextmv components.
 */

/**
 * Validate a traffic magnifier value.
 *
 * Rules:
 *  - Empty / undefined / null → valid (means "no multiplier for this hour")
 *  - Must be a valid number
 *  - Must be >= 1
 *  - Must be <= 10
 *  - At most 2 decimal places
 *
 * @param {string|number|null|undefined} value
 * @returns {{ valid: boolean, error: string|null }}
 */
function validateMagnifier(value) {
  if (value === '' || value === undefined || value === null) {
    return { valid: true, error: null };
  }

  const num = Number.parseFloat(value);

  if (Number.isNaN(num)) {
    return { valid: false, error: 'Magnifier must be a valid number' };
  }

  if (num < 1) {
    return { valid: false, error: 'Magnifier cannot be less than 1' };
  }

  if (num > 10) {
    return { valid: false, error: 'Magnifier cannot be greater than 10' };
  }

  const decimalPart = String(value).split('.')[1];
  if (decimalPart && decimalPart.length > 2) {
    return {
      valid: false,
      error: 'Magnifier can have maximum 2 decimal places',
    };
  }

  return { valid: true, error: null };
}

export default validateMagnifier;
